import React from 'react';
/**
 * @deprecated
 */
export const DispatcherExperimentsProvider = ({ children, ...props }) => React.createElement(DispatcherContext.Provider, { value: props }, children);
/**
 * @deprecated
 */
export const DispatcherContext = React.createContext(null);
